import React, { type JSX } from 'react';
import Bar, { type BarProps } from '@resources/js/components/Bar/Bar';
import Tooltip, {
  type TooltipProps,
} from '@resources/js/components/Tooltip/Tooltip';

export default function Bars({
  bars,
  tooltipProps,
}: {
  bars: BarProps[];
  tooltipProps?: Omit<TooltipProps, 'kind' | 'children'>;
}): JSX.Element {
  const child = (
    <div className='bars'>
      {bars.map((bar, index) => (
        <Bar
          key={index}
          {...bar}
          className={bar.className ? `${bar.className} bars__bar` : 'bars__bar'}
        />
      ))}
    </div>
  );

  if (tooltipProps) {
    return (
      <Tooltip
        {...tooltipProps}
        placementOptions={{
          alignment: 'start',
        }}
        triggerProps={{ style: { width: '100%' } }}
      >
        {child}
      </Tooltip>
    );
  }

  return child;
}
